/*
 * @Author: W9013327 v-maijiahua@oppo.com
 * @Date: 2023-03-11 18:29:41
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-03-20 16:57:57
 * @FilePath: \sns-user-frontend\src\utils\encrypt.js
 * @Description: 
 */
import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'
import { mode } from 'crypto-js/core';
import AES from 'crypto-js/aes';
import Utf8 from 'crypto-js/enc-utf8';
import Pkcs7 from 'crypto-js/pad-pkcs7';

// 密钥对生成 http://web.chacuo.net/netrsakeypair; 把下面生成的公钥、私钥换成自己生成的即可
//RSA公钥
const publicKey = 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAps_1ZfXF4GQHIdjhkjoNQNF9zmnSfXYonbv2b5T58UlZ4yUVSeIKkguVt8FAQ6gDrbocCXjC6O74vcRV0eRIcWXFnFE_y69PRg53XWaMZhV9OzXxc2i0Z5Al3uMhySx8V8h3tJ-ptII64b6Xp3MkCao4_ktqXybh0Fsk24W_c3lYbbRSqcc4_H_FcundKq-BFvRk9TerYKvHEGu7Laui0-l0o3qeef4L8h1wYZCjaqvoiNdjkWTn338q1EtOm3DFzB5S31A2chtOd-ReVQo6ydsOmU83RkR0W2UiZe96w9BXAXBSQDIi2BT-38dgOza1LjhYA-y_hBA7q1izgQVGXQIDAQAB'
const privateKey=''

// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对数据进行加密
}

// 解密
export function decrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(privateKey) // 设置私钥
  return encryptor.decrypt(txt) // 对数据进行解密
}

/**
 * CryptoJS AES 加密。str 是需要加密的字符串明文；key 是密钥；iv 是偏移向量，默认 iv 是 16 个 0（这个称为初始化向量），我们可以指定 iv 来进行加解密，加大破解难度；返回值为加密结果字符串密文
 *
 * @param {String} str
 * @param {String} key
 * @param {String} iv
 * @return {String}
 */
 const KEY = getKey(16)
 const IV = getKey(16)

export const aesInfo = {
  key: KEY,
  iv: IV
}

 export function aesEncrypt (str, dummy, deIv) {
    const key = Utf8.parse(dummy || KEY) // 将 key 转为 128bit 格式
    const iv = Utf8.parse(deIv || IV);
    const encrypted = AES.encrypt(str, key, {
      iv,
      mode: mode.CBC,
      padding: Pkcs7,
    }).toString()
    return encrypted // AES 加密生成的密文是一个对象，如果直接将其转为字符串是一个 Base64 编码串，在 encrypted.ciphertext 上的属性转为字符串才是后端需要的密文格式
  }
  /**
   * CryptoJS AES 解密。encryptedStr 字符串密文；key 是密钥；iv 是偏移量；返回结果为解密后的结果明文
   * 注意：key 与 iv 要与上面加密使用的 key 与 iv 保持一致
   *
   * @param {String} encryptedStr
   * @param {String} key
   * @param {String} iv
   * @return {String}
   */
export function aesDecrypt (encryptedStr, dummy, deIv) {
  if(!encryptedStr){
    return ""
  }
  // const encryptedHexStr = CryptoJS.enc.Hex.parse(encryptedStr) // 把密文由 128 bit 转为十六进制
  // const encryptedBase64Str = CryptoJS.enc.Base64.stringify(encryptedHexStr) // 再转为 Base64 编码的字符串
  const key = Utf8.parse(dummy || KEY) // 将 key 转为 128bit 格式
  const iv = Utf8.parse(deIv || IV);
  const decrypted = AES.decrypt(encryptedStr, key, {
    iv,
    mode: mode.CBC,
    padding: Pkcs7,
  }).toString(Utf8) // 解密
  return decrypted // 经过 AES 解密后，依然是一个对象，将其变成明文就需要按照 Utf8 格式转为字符串
}
/**
 * 生成密钥
 * @param n 生成多少位的密钥(默认8位)
 */
function getKey(n) {
  let chars = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];
  if (n == null) {
    n = 8;
  }
  let res = "";
  for (let i = 0; i < n; i++) {
    let id = Math.ceil(Math.random() * 35);
    res += chars[id];
  }
  return res;
}